// extracted by mini-css-extract-plugin
module.exports = {"className":"ne-NP_className__49qsF"};